var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trax-actions"},[_c('button',{staticClass:"btn btn-link btn-just-icon btn-sm",on:{"click":_vm.editItem}},[_c('i',{staticClass:"material-icons"},[_vm._v("edit")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-link btn-just-icon btn-sm",on:{"click":_vm.deleteItem}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }